import Vue from "vue";
import VueRouter from "vue-router";
import Vue2Filters from "vue2-filters";
import AsyncComputed from 'vue-async-computed'

import { stickyHeader } from "./stickyNav";
import { loading } from "./components/loading";
import { goodsStore } from "./components/goods/store";
const Goods = () => import("./components/goods.vue");
const RegionalSummaries = () => import("./components/goods_regional_summaries.vue");
const Investments = () => import("./components/investments.vue");
const TotalTrade = () => import("./components/total.vue");
const Services = () => import("./components/services.vue");
const Meetings = () => import("./components/meetings.vue");
const Disputes = () => import("./components/disputes.vue");
const Scorecard = () => import("./components/scorecard.vue");
const ScorecardUSMCAImplementation = () =>
  import("./components/scorecard_usmca_implementation.vue");
const ScorecardDomesticImplementation = () =>
  import("./components/scorecard_domestic_implementation.vue");
const ScorecardUSMCADisputes = () =>
  import("./components/scorecard_usmca_disputes.vue");

Object.defineProperty(String.prototype, "ucfirst", {
  value: function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false,
});

Vue.observable(goodsStore);

export function app() {
  console.log("I've been initialized!");

  Vue.use(VueRouter);
  Vue.use(Vue2Filters);
  Vue.use(AsyncComputed);

  function run() {
    const routes = [
      { path: "/goods", component: Goods, name: "Goods" },
      {
        path: "/regional_summaries",
        component: RegionalSummaries,
        name: "Goods > Regional Summaries"
      },
      { path: "/services", component: Services, name: "Services" },
      { path: "/investments", component: Investments, name: "Investment" },
      { path: "/total", component: TotalTrade, name: "Total Trade" },
      { path: "/meetings", component: Meetings, name: "Meetings" },
      { path: "/disputes", component: Disputes, name: "Disputes" },
      { path: "/scorecard", component: Scorecard, name: "Scorecard" },
      {
        path: "/usmca_implementation",
        component: ScorecardUSMCAImplementation,
        name: "Scorecard > USMCA Meetings & Activity",
      },
      {
        path: "/domestic_implementation",
        component: ScorecardDomesticImplementation,
        name: "Scorecard > Domestic Implementation",
      },
      {
        path: "/usmca_disputes",
        component: ScorecardUSMCADisputes,
        name: "Scorecard > USMCA Disputes",
      },
      { path: "/", redirect: "/goods" },
    ];

    const router = new VueRouter({
      routes,
      scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0, behavior: "smooth" };
      },
    });

    Object.defineProperty(Vue.prototype, "$goods", {
      get() {
        return goodsStore;
      },

      set(value) {
        goodsStore = value;
      },
    });

    const app = new Vue({
      router,
    }).$mount("#holder");

    stickyHeader(router);

    router.beforeEach((to, from, next) => {
      if (to?.name?.toLowerCase() !== "goods") {
        loading();
      }
      next();
    });

    router.afterEach((to, from) => {
      document.getElementById("usmca--mobile-nav").innerText = to.name;
    });
  }

  run();
  // loading();
}
